module.exports = __webpack_public_path__ + "media/audio28.25de261c.mp3";